import { render, staticRenderFns } from "./FavoriteList.vue?vue&type=template&id=0631a4fa&scoped=true"
import script from "./FavoriteList.vue?vue&type=script&lang=js"
export * from "./FavoriteList.vue?vue&type=script&lang=js"
import style0 from "./FavoriteList.vue?vue&type=style&index=0&id=0631a4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631a4fa",
  null
  
)

export default component.exports